import type { DentalAnnotations, DentalRevision, DentalTask } from './types';

// Mirror the server's documented normalization of annotation records; this
// compares content and identities, independent of JSON object key order.
function normalized(annotations: DentalAnnotations) {
  const result = JSON.parse(JSON.stringify(annotations)) as DentalAnnotations;
  result.instances.forEach(row => { row.id = row.id.toLowerCase(); row.name = row.name.trim(); });
  result.landmarks.forEach(row => { row.id = row.id.toLowerCase(); });
  if (result.registration) {
    const r = result.registration; r.convention = 'row-major-source-to-target';
    r.method ??= 'manual-adjustment'; r.landmarkPairs ??= [];
    r.landmarkPairs.forEach(pair => { pair.id = pair.id.toLowerCase(); });
    r.rmsMm = r.landmarkPairs.length ? Math.sqrt(r.landmarkPairs.reduce((sum, pair) => sum + pair.target.reduce((s, target, axis) => {
      const at = axis * 4; const transformed = r.matrix[at] * pair.source[0] + r.matrix[at + 1] * pair.source[1] + r.matrix[at + 2] * pair.source[2] + r.matrix[at + 3];
      return s + (transformed - target) ** 2;
    }, 0), 0) / r.landmarkPairs.length) : null;
  }
  return result;
}
function equal(a: unknown, b: unknown): boolean {
  if (typeof a === 'number' && typeof b === 'number') return Math.abs(a - b) <= 1e-8;
  if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every((value, i) => equal(value, b[i]));
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    const keys = Object.keys(a); return keys.length === Object.keys(b).length && keys.every(key => key in b && equal((a as Record<string, unknown>)[key], (b as Record<string, unknown>)[key]));
  }
  return a === b;
}
export function verifySaveResult(taskId: string, baseVersion: number, submitted: DentalAnnotations, revision: DentalRevision) {
  if (revision.taskId !== taskId || revision.number !== baseVersion + 1 || !equal(normalized(submitted), normalized(revision.annotations))) throw new Error('服务器返回的保存版本或标注内容与本次提交不一致。');
}
export function verifyLatestSave(latest: DentalTask, revision: DentalRevision, submitted: DentalAnnotations) {
  verifySaveResult(latest.id, revision.number - 1, submitted, revision);
  if (latest.activeRevisionId !== revision.id || latest.version !== revision.number || latest.revision.id !== revision.id || latest.revision.number !== revision.number || latest.revision.taskId !== latest.id || !equal(normalized(latest.revision.annotations), normalized(revision.annotations))) throw new Error('服务器最新版本与本次保存不一致，未确认保存成功。');
}
